
import React from "react";
import { Button, DefaultComponentProps, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography } from '@albo-ui/core';

export type ConfirmDialogDialogProps = {
    onConfirm: () => void;
    onClose: () => void;
    open: boolean;
    title: string;
    message: string;
} & DefaultComponentProps;

export const ConfirmationDialog = ({ onConfirm, onClose, open, title, message }: ConfirmDialogDialogProps) => {
    return (
        <Dialog onClose={onClose} open={open}>
            <DialogTitle>
                <Typography variant="h2">{title}</Typography>
            </DialogTitle>
            <DialogContent>
                <FlexGrid 
                    // container
                    fullHeight
                    fullWidth
                    direction="column"
                    justify='space-between'
                    alignItems='flex-start'
                    spacing={2}
                    >
                    <Typography variant="paragraph">{message}</Typography>
                </FlexGrid>
            </DialogContent>
            <DialogActions>
                <FlexGrid
                    // container
                    fullHeight
                    fullWidth
                    justify='space-between'
                    alignItems='flex-end'
                    style={{ marginTop: '20px', display: "flex" }}
                >
                    <FlexGrid item>
                        <Button onClick={onClose} buttonType='secondary' size='normal'>
                            Cancelar
                        </Button>
                    </FlexGrid>
                    <FlexGrid item>
                        <Button onClick={onConfirm} size='normal'>
                            Aceptar
                        </Button>
                    </FlexGrid>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    )
}